export default "__VITE_ASSET__DhZzV2TF__"